import React from 'react'
import { Col, Row } from 'react-flexbox-grid'
import { localize } from '../../../util/Localizer'

const TableRow = (props) => {
  let { title, value } = props

  if (props.format === 'currency') {
    // TODO: do this properly
    value = (<p className='value'>${value}</p>)
  } else {
    value = (<p className='value'>{value}</p>)
  }

  return (
    <Row start='sm' center='xs' >
      <Col xs={12} sm={5}>
        <p className='title'>{localize(title)}</p>
      </Col>
      <Col xs={5} smOffset={2}>
        {value}
      </Col>
    </Row>
  )
}

export default TableRow



// WEBPACK FOOTER //
// ./src/widgets/Member/Hsca/TableRow.js